import { render, staticRenderFns } from "./MethodRevolut.vue?vue&type=template&id=91092538&scoped=true&"
import script from "./MethodRevolut.vue?vue&type=script&lang=js&"
export * from "./MethodRevolut.vue?vue&type=script&lang=js&"
import style0 from "./MethodRevolut.vue?vue&type=style&index=0&id=91092538&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91092538",
  null
  
)

export default component.exports